import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const NavigationContainer = styled.header`
  position: fixed;
  z-index: 200;
  width: 100vw;
`;

export const NavigationTopbarContainer = styled.nav`
  border-bottom: 1px solid #8f9bb729;
  height: 64px;
  background-color: rgba(22, 22, 26, 0.7);
  transition: background-color 0.5s, box-shadow 0.5s;
  backdrop-filter: blur(5px);
`;

export const NavigationTopbarInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  position: relative;
  margin: 0 auto;
  padding: 0 72px;
  max-width: 1200px;

  @media (max-width: 600px) {
    padding: 0px 42px;
  }
`;

export const NavigationSidebarContainer = styled.aside<{
  show: boolean;
}>`
  position: absolute;
  left: 0;
  display: flex;
  flex-direction: column;
  padding: 24px 56px 24px 56px;
  background-color: ${({ theme }) => theme.colorsPalette.black.default};
  height: 100vh;
  width: 50vw;
  max-width: 240px;
  box-shadow: 0px 12px 0px ${({ theme }) => theme.colorsPalette.black.default};
  transform: ${({ show }) => (!show ? "translateX(-100%)" : "translateX(0)")};
  transition: transform 0.3s ease-out;
  z-index: 100;

  @media (max-width: 600px) {
    min-width: 100px;
    padding: 24px;
  }
`;

export const NavigationBackdropContainer = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? "block" : "none")};
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 50;
`;

export const NavigationLink = styled(NavLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.colorsPalette.gray.default};
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1.4;
  transition: all 0.3s;

  &:hover {
    color: #fff;
    background-color: ${({ theme }) => theme.colorsPalette.black.light};
  }

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  @media (max-width: 600px) {
    margin: 4px 0;

    &:not(:last-child) {
      margin-right: 0;
    }
  }
`;

export const ToggleNavSidebarButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  &:active {
    outline: none;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 600px) {
    position: unset;
  }
`;

export const AnnouncementBarContainer = styled.aside`
  width: 100vw;
  background-color: #e34040;
  color: ${({ theme }) => theme.colorsPalette.white.default};
  transition: background-color 0.5s, box-shadow 0.5s;
  backdrop-filter: blur(5px);
`;

export const AnnouncementBarInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  padding: 12px 56px;
  margin: 0 auto;
  max-width: 1200px;
`;

export const AnnouncementCloseButton = styled.button`
  position: absolute;
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;
